var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "10 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_185_318)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 7,
    width: 66,
    height: 66,
    rx: 10,
    fill: "#FF0D37"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.1347 29.9179C63.6505 28.1187 62.2319 26.7005 60.433 26.216C57.1463 25.3165 43.9996 25.3165 43.9996 25.3165C43.9996 25.3165 30.8532 25.3165 27.5665 26.1817C25.8022 26.6659 24.349 28.119 23.8648 29.9179C23 33.2043 23 40.0199 23 40.0199C23 40.0199 23 46.8698 23.8648 50.1219C24.3493 51.9208 25.7676 53.3394 27.5668 53.8239C30.8878 54.7233 43.9999 54.7233 43.9999 54.7233C43.9999 54.7233 57.1463 54.7233 60.433 53.8582C62.2322 53.374 63.6505 51.9554 64.135 50.1565C64.9998 46.8698 64.9998 40.0545 64.9998 40.0545C64.9998 40.0545 65.0344 33.2043 64.1347 29.9179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8138 46.3164L50.746 40.0199L39.8138 33.7234V46.3164Z",
    fill: "#ED3237"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 11,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#FF0D37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4167 18.5L62.875 24.0417L59.9583 21.125L55.5833 25.5",
    stroke: "#EAE7E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9167 18.5H68.4167V22",
    stroke: "#EAE7E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_185_318",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_185_318"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_185_318"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_185_318",
    result: "effect2_dropShadow_185_318"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_185_318",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(23 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame4);
export default __webpack_public_path__ + "static/media/Frame4.c6e43ef621323c30df66900990759233.svg";
export { ForwardRef as ReactComponent };